import {BaseQueryApi} from "@reduxjs/toolkit/query";
import {useCallback, useState} from "react";
import {OtsAsyncThunkConfigExtra, OtsState} from "../store/ots-store";
import {removeUndefined} from "../util/util";
import {TtaDisputeReportCriteria,} from "../model/report/report";
import {buildStandardHeaders} from "../store/ots-api";

export type UseDownloadTtaDisputeReportProps = {
  baseQueryApi: BaseQueryApi
}

export type UseDownloadTtaDisputeReportResult = {
  downloadTtaDisputeReport: (criteria: TtaDisputeReportCriteria) => void
  report?: string
  error?: any
  loading: boolean
}

export const useDownloadTtaDisputeReport = (props: UseDownloadTtaDisputeReportProps): UseDownloadTtaDisputeReportResult => {
  const {baseQueryApi} = props

  const [_report, _setReport] = useState<string | undefined>(undefined)
  const [_error, _setError] = useState()
  const [_loading, _setLoading] = useState<boolean>(false)

  const _downloadTtaDisputeReport = useCallback((criteria: TtaDisputeReportCriteria) => {

    _setReport(undefined)
    _setLoading(true)
    _setError(undefined)

    const headers = buildStandardHeaders(baseQueryApi)
    headers["Accept"] = 'application/pdf'
    headers["Content-Type"] = 'application/pdf'

    const request: RequestInit = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(criteria),
    }

    const baseUrl = (baseQueryApi.extra as OtsAsyncThunkConfigExtra).baseUrl;
    const url = `${baseUrl}/reports/dispute`;

    window.fetch(url, request)
      .then((response) => {
        response.json()
          .then((json) => {
            _setReport(json?.reportUrl)
          })
          .catch((rejected) => {
            _setError(rejected)
            _setLoading(false)
          })
          .finally(() => {
            _setLoading(false)
          })
      })
      .catch((rejected) => {
        _setError(rejected)
        _setLoading(false)
      })
  }, [baseQueryApi])

  return {
    downloadTtaDisputeReport: _downloadTtaDisputeReport,
    report: _report,
    error: _error,
    loading: _loading,
  }
}
